import React, { useContext, useEffect, useState } from "react";
import Table from "../../components/table/table";
import { UserContext } from "../../contexts/UserContext";
import { AssignAgent, GetListeAgent, GetListSimulationsSupAgent } from "../../helpers/api";
import { io } from "socket.io-client";
import { BASE_URL_SOCKET } from "../../helpers/config";
import IconAgnetAtribue from "../../components/icons/iconAgnetAtribue";
import { useActionMap } from "../../hooks/useActionMap";
import CustomSelect from "../../components/CustomSelect";
import { toast, ToastContainer } from "react-toastify";

export default function FirstHomeContainer() {
  const { user, setRetardCall } = useContext(UserContext);
  const [apiResponse, setApiResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [now, setNow] = useState(new Date());

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [isOpenListeAgent,setIsOpenListeAgent]=useState(false)
  const [listeAgent, setListeAgent]=useState([])
  const [selectedUser, setSelectedUser]=useState('')
  const [selectedAgnet, setSelectedAgent]=useState('')
  const actionMap = useActionMap();

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);


useEffect(() => {
  const fetchAgents = async () => {
    try {
      const agents = await GetListeAgent(user?.accessToken);
    
        const formattedAgents = agents.data.map((item) => ({
          id: item.id,
          value: item.firstName,
          label: item.firstName,
        }));

        setListeAgent(formattedAgents);
      
    } catch (error) {
      console.error(error);
    }
  };

  fetchAgents();
}, [user]);


//   const handleListeAgent=(row)=>{
//    setOpenRowId(row.id)
//       setOpenListAgent(true)

//   }

  useEffect(() => {
    if (!user?.accessToken) return;

    const socket = io(BASE_URL_SOCKET, {
      auth: {
        userId: user.user.id,
        role: user.user.role,
      },
    });

    socket.on("connect", () => {
      console.log("Connecté à Socket.IO, id:", socket.id);
    });

    // Événement : Ajout ou Mise à jour
    socket.on("upsertSimulation", (simulation) => {

      setApiResponse((prev) => {
        const index = prev.findIndex((s) => s.id === simulation.id);
        if (index !== -1) {
          // Mise à jour : on remplace l'existante
          const newData = [...prev];
          newData[index] = simulation;
          return newData;
        } else {
          // Ajout : on l'ajoute au début de la liste
          return [simulation, ...prev];
        }
      });
    });

    //Événement : afficher l’agent assigné pour toutes les simulations du client associé.
    socket.on('agentAssigned', (data) => {
      setApiResponse((prev) => 
        prev.map((item) =>
        item.userId===data.clientId
          ? {...item,  
            // agentFirstName: data.agentAssignee,
            agentAssignee: data.agentAssignee
          }
          :item

      ))
})
    


    // Événement : Suppression (Conditions non respectées)
    socket.on("simulationInProgress", (data) => {
        setApiResponse((prev) =>
          prev.map((item) =>
            item.userId === data.clientId
              ? {
                  ...item,
                  agentFirstName: data.agentFirstName,
                  agentLastName: data.agentLastName,
                }
              : item
          )
        );


  //évenement: Affectation d'agent un cilent 

  

  //évenement : affectation de client a un agent 
  // socket.on ('agentAssigned', (data)=>{
  //   console.log('soketData', data)
  // })



      // setApiResponse((prev) => prev.filter((s) => s.userId !== data.clientId));
    });

    // Événement : Suppression après appel par un agent
    // socket.on("deleteSimulationAgent", ({ simulationId }) => {
    //   console.log("simulationId", simulationId);
    //   setApiResponse((prev) => prev.filter((s) => s.id !== simulationId));
    // });

    // Cleanup à la fermeture du composant
    return () => {
      socket.disconnect();
    };
  }, [user?.accessToken]);

  const handleSlectedAgent= async (clientId, agent)=>{
    const idAgent = listeAgent.find((item)=>item.value===agent).id
    if (!idAgent || !user.accessToken) return
    try { 
     const response= await AssignAgent(clientId, idAgent, user?.accessToken) 
     if(response.success)   
     { 
      setSelectedAgent(agent)
       toast.success(`Le client a été affecté à l'agent ${agent} avec succès`);       
    }
     }
     catch (err){
      console.error(err)
      toast.error("Une erreur est survenue")
     }

  }
  useEffect(()=>{
    if(isOpenListeAgent && !selectedAgnet )
    { 
    //  setIsOpenListeAgent(false)

    }
  },[isOpenListeAgent, selectedAgnet])


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetListSimulationsSupAgent(
          user?.accessToken,
          currentPage,
          pageSize
        );
        if (response?.success) {
          setApiResponse(response?.data?.simulations || []);
          setTotalPage(response.data.total);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setIsLoading(false);
      }
    };
    if (user?.accessToken) fetchData();
  }, [user?.accessToken, currentPage, pageSize]);


// Calcul du nombre d'appels en retard
  useEffect(() => {
      const retardUsers = apiResponse.filter((item) => {
  
        const createdTime = new Date(item.createdAt).getTime()
  
        return (now.getTime() - createdTime) / 60000 >= 5
      })
  
      setRetardCall(retardUsers.length)
  
      localStorage.setItem(
        'retardCall',
        JSON.stringify(retardUsers.length)
      )
    }, [apiResponse, now])

  const columns = [
    {
      label: "Order",
      key: "order",
      customRenderers: (row) => (
        <div className="flex flex-col items-start ">
          <span>{row.order}</span>
          {(now - new Date(row.createdAt)) / 60000 >= 5 &&
            !row?.agentFirstName  &&  (
              <span className="text-[8px] font-bold  text-[#FF3B30] animate-pulse ">
                RETARD +5 MIN
              </span>
            )}
        </div>
      ),
    },
    {
      label: "Nom du Client",
      key: "firstName",
      customRenderers: (row) => (
        <div>
          <a
            href={`/detailuser/${row.userId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#777777] underline  hover:text-blue-800"
            onClick={(e) => {
              localStorage.setItem(
                "varaction",
                JSON.stringify({ actionId: row.id, actionType: row.action })
              );
              e.stopPropagation();
            }}
          >
            {row.firstName} {row.lastName}
          </a>
        </div>
      ),
    },
    {
      label: "Pays",
      key: "countryName",
      customRenderers: (row) => (
        <div className="text-left px-2 text-gray-700 font-medium">
          {row.countryName}
        </div>
      ),
    },
    {
      label: "Téléphone",
      key: "phone",
      customRenderers: (row) => (
        <div className="text-left px-2 text-gray-600 font-mono">
          {row.phone}
        </div>
      ),
    },

    {
      label: "Action",
      key: "action",
      customRenderers: (row) => {
        const actionItem = actionMap[row.action];
        return (
          <>
            {actionItem && (
              <div className="text-left flex items-center gap-2 bg-white rounded-[40px] h-[32px] w-[120px]  shadow-[0px_2px_10px_rgba(0,0,0,0.15)] text-[#000] text-[12px] px-2">
                <img src={actionItem.icon} alt="" /> {actionItem.type}
              </div>
            )}
          </>
        );
      },
    },
    
    {
      label: "Attribuer",
      key: "Attribuer",
      customRenderers: (row) => (
        <div className="w-[100px] flex justify-center  ">
          {row.agentFirstName || row?.agentAssignee ? 
          <div className={`${row.agentAssignee? 'text-[#34C759]' :'text-[#000]'} font-bold cursor-default `}>{row.agentAssignee ? row?.agentAssignee :row.agentFirstName } </div>
          :
          isOpenListeAgent && selectedUser=== row.id ?
           <CustomSelect id="tabKyc" isOpen={isOpenListeAgent} setIsOpenListeAgent={setIsOpenListeAgent} isOpenListeAgent={isOpenListeAgent}  onChange={(val)=>handleSlectedAgent(row.userId,val)} value={selectedAgnet} options={listeAgent} sizeTexte='text-[12px]' styleInput='h-[32px] rounded-[8px] w-[100px] ' placeholder='Tous' styleSlect='top-full'/>

            : <IconAgnetAtribue
            onClick={()=>{
              setIsOpenListeAgent(true)
              setSelectedUser(row.id)
              setSelectedAgent('')
            }}
            className={` ${
              (now - new Date(row.createdAt)) / 60000 >= 5
              //  && !row?.agentFirstName
                ? "stroke-[#FF3B30]"
                : "stroke-[#34C759]"
            }`}
          />
          } 
        </div>
      ),
    },
  ];

  return (
    <div className=" min-h-screen w-full font-sans">
      <ToastContainer/>
      <div className="bg-white rounded-xl shadow-2xl border border-[#EEEEEE] w-full p-4 md:p-6 overflow-hidden">
        <Table
          setPageSize={setPageSize}
          pageSize={pageSize}
          currentPage={currentPage}
          totalPage={totalPage}
          setCurrentPage={setCurrentPage}
          data={apiResponse}
          columns={columns}
          loading={isLoading}
          excel={true}
          rowClassName={(row) => {
            const diff = (now - new Date(row.createdAt)) / 60000;
            return row?.agentFirstName
              ? "border-l-4 border-l-[#34C759]"
              : diff >= 5 && !row?.agentFirstName
              ? "border-l-4 border-l-[#FF3B30]"
              : "border-l-4 border-l-[#5754E5]";
          }}
        />
      </div>

    </div>
  );
}
